import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../../../core/authorization/permission.service';
import { PlatformContextService } from '../../../core/platform/platform-context.service';
import { authGuard } from '../../../core/authentication/auth.guard';
import { firstValueFrom, isObservable } from 'rxjs';

export const captureWeekGuard: CanActivateFn = async (route, state) => {
  const permissions = inject(PermissionService),
    router = inject(Router),
    context = inject(PlatformContextService);
  // This route prepares identity/Tenant/context before checking capabilities. Separate canActivate guards run concurrently.
  const auth = authGuard(route, state);
  const ready = isObservable(auth) ? await firstValueFrom(auth) : await auth;
  if (ready !== true) return ready;
  if (!permissions.isLoaded() && !(await permissions.load())) {
    context.markApplicationError();
    return false;
  }
  return ['prenomina.captura.general', 'prenomina.captura.lider'].some((p) =>
    permissions.hasPermission(p),
  )
    ? true
    : router.createUrlTree(['/access-denied']);
};
